module.exports = __webpack_public_path__ + "img/img_blog_04.ef6cc3d3.jpg";